export default [
    {
        name: 'year',
        props: {
            hideDetails: true,
            label: 'Año',
            mask: '####',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'month',
        props: {
            hideDetails: true,
            label: 'Mes',
            items: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre',
            ].map((m, i) => ({ text: m, value: i + 1 })),
        },
        type: 'autocomplete',
        value: '',
    },
]
